import {classNames} from "shared/lib/classNames/classNames";
import cls from "./HeaderBlock.module.scss";
import {ComponentType, FC, ReactNode} from "react";
import Title, {TitleProps} from "shared/ui/Title/Title";
import Paragraph, {ParagraphProps} from "shared/ui/Paragraph/Paragraph";

interface HeaderBlockProps {
    className?: string;
    titleProps: TitleProps;
    paragraphProps?: ParagraphProps;
    text?: string;
    padded?: boolean;
}

const HeaderBlock = ({ className, titleProps, paragraphProps, text, padded}: HeaderBlockProps) => {

    return (
        <div className={classNames(cls.HeaderBlock, {
            [cls.HeaderBlock_padded]: padded
        }, [className])}>
            <Title {...titleProps} className={classNames(cls.HeaderBlock__header, {}, [titleProps.className])} />
            <Paragraph {...paragraphProps} className={classNames(cls.HeaderBlock__subtext, {}, ["preWrap"])}>
                {text}
            </Paragraph>
        </div>
    )
}

export default HeaderBlock;